import { ref } from 'vue';
import type { ResultsCompany, ResultsLogoType } from '@/components/widget/results/results-view.types';

const getLogoPath = (logoName: string): string => {
  if (typeof window === 'undefined') return `/${logoName}`;

  const scripts = document.getElementsByTagName('script');
  for (let i = scripts.length - 1; i >= 0; i--) {
    const script = scripts[i];
    if (script.src && script.src.includes('cotizador-widget')) {
      const scriptPath = script.src.substring(0, script.src.lastIndexOf('/'));
      return `${scriptPath}/${logoName}`;
    }
  }

  const basePath = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'));
  return `${basePath}/${logoName}`;
};

const DISPLAY_NAMES: Record<ResultsCompany, string> = {
  QUALITAS: 'Quálitas',
  ANA: 'ANA Seguros',
  CHUBB: 'Chubb',
};

const LOGO_TYPES: Record<ResultsCompany, ResultsLogoType> = {
  QUALITAS: 'qualitas',
  ANA: 'ana',
  CHUBB: 'chubb',
};

export function useCompanyLogos() {
  const qualitasLogo = ref(getLogoPath('qualitas-logo.png'));
  const anaLogo = ref(getLogoPath('ana-logo.png'));
  const chubbLogo = ref(getLogoPath('chubb-logo.png'));
  const logoRefs = { qualitas: qualitasLogo, ana: anaLogo, chubb: chubbLogo };

  const handleImageError = (logoType: ResultsLogoType): void => {
    logoRefs[logoType].value = `/${logoType}-logo.png`;
  };

  const companyDisplayName = (company: ResultsCompany): string => DISPLAY_NAMES[company];
  const companyLogoType = (company: ResultsCompany): ResultsLogoType => LOGO_TYPES[company];
  const companyLogoSrc = (company: ResultsCompany): string => logoRefs[LOGO_TYPES[company]].value;

  return {
    qualitasLogo,
    anaLogo,
    chubbLogo,
    handleImageError,
    companyDisplayName,
    companyLogoSrc,
    companyLogoType,
  };
}
